import Vue from 'vue';
import Vuex from 'vuex';
import storage from '@/util/storeage.js';
import server from '@/services/server.js';
import router from '../router/index';
import i18n from '../language/index';
Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    /* 切换账号除copy外不需要重置的state */
    state: {
        language: storage.ls.get('language') || 'zh', // 语言环境
        loading: false,
        dataType: 'all',
        checkList: [], // 选中的梯队列表
        groupId:'', // 集团的id
        tenantId: '', // 训练营机构id
        tenantData: {}, // 大集团信息
        childTenantData:{}, // 子客户详情
        userData: {}, // 用户信息
        token: storage.ss.get('token') || '', // 登录凭证
        menuList: [], // 菜单
        authButtons: [], // 按钮权限
        playerPositionMap: {}, // 球员位置map映射关系 如: forward: { label: '前锋', labelEn: 'Forward' }
        coachPositionMap: {}, // 教练员职位map映射关系 如: headCoach: { label: '主教练', labelEn: 'Head Coach' }
        playerPositionList: [], // 球员位置列表
        coachPositionList: [], // 教练员职位列表
        // 选择的城市信息
        cityData: JSON.stringify(storage.ss.get('cityData')),
        // ca
        CACourse: {}, // 当前课程
        CASchedule: {}, // 当前日程
        // ca end
        // 训练营
        campMgmt: {}, // 训练营管理 管理模块
        trainingCamp: {}, // 训练营营地
        // 训练营end
        currentAssess: {}, // 考核中的模板
        playerComparisonList:[], // 精英球员内对比球员列表
    },
    getters: {
        playerPositionMap(state) {
            return state.playerPositionMap || {};
        },
        coachPositionMap(state) {
            return state.coachPositionMap || {};
        },
        playerPositionList(state) {
            return state.playerPositionList || [];
        },
        coachPositionList(state) {
            return state.coachPositionList || [];
        },
        creatorForm(state) {
            return {
                creatorName: state.userData.name || '',
                creatorNameEn: state.userData.nameEn || '',
                creatorId: state.userData.id || '',
                creatorAvatar: state.userData.avatar || ''
            }
        }
    },

    mutations: {
        // 设置语言
        setLanguage(state, language) {
            state.language = language;
            i18n.locale = language;
            storage.ls.set('language', language);
        },
        // 设置 loading
        setLoading(state, data) {
            state.loading = data;
        },
        // 设置 token
        setToken(state, token) {
            state.token = token;
            storage.ss.set('token', token);
            storage.ss.set('store', state);
        },
        setDataType(state, type) {
            state.dataType = type;
            storage.ss.set('dataType', type);
            storage.ss.set('store', state);
        },
        // 设置 机构的tenantId
        setTenant(state, tenantId) {
            state.tenantId = tenantId;
            storage.ss.set('tenantId', tenantId);
        },
        // 设置 集团的groupId
        setGroup(state, groupId) {
            state.groupId = groupId;
            storage.ss.set('groupId', groupId);
        },
        // 设置 tenantData
        setTenantData(state, tenantData) {
            state.tenantData = tenantData;
        },
        // 设置子客户的tenantData
        setChildTenantData(state,tenantData){
            state.childTenantData = tenantData;
        },
        // 设置 userData
        setUserData(state, userData) {
            state.userData = userData;
        },
        // 修改菜单
        changeMenu(state, data) {
            console.log(data, 'data');
            state.menuList = data;
            // storage.ss.set('menuList', state);
        },
        // 设置菜单信息
        setMenu(state, { route = [], userRoute = [] }) {
            if (route.length) {
                // 构建所有菜单list
                let res = arrToTree(route);

                // 导航时，开启或关闭使用 check
                // state.menuList = res;
                // 构建路由信息
                let dynamicRouter = router.$formatRoutes(res, true);
                // router.addRoutes([...dynamicRouter]);
                let length = dynamicRouter.length;
                for (let i = 0; i < length; i += 1) {
                    const element = dynamicRouter[i];
                    router.addRoute(element);
                }
                // 构建按钮权限list
                let buttonList = route.filter((item) => item.type === 'button');
                state.authButtons = buttonList;
                // 重构用户菜单
                state.menuList = resetMenu(res, userRoute);
            }
            // 一维数组构建tree结构
            function arrToTree(arr) {
                const result = []; // 存放结果集
                const itemMap = {}; //
                // 先转成map存储
                for (const item of arr) {
                    itemMap[item.id] = { ...item, children: [] };
                }

                for (const item of arr) {
                    const id = item.id;
                    const parentId = item.parentId;
                    const treeItem = itemMap[id];
                    if (!parentId) {
                        result.push(treeItem);
                    } else {
                        if (!itemMap[parentId]) {
                            itemMap[parentId] = {
                                children: [],
                            };
                        }
                        itemMap[parentId].children.push(treeItem);
                    }
                }
                // 二级菜单根据order排序
                result.forEach((item) => {
                    item.children.sort((a, b) => a.order - b.order);
                });
                return result;
            }
            // 根据用户菜单，聪所有菜单筛选重组
            function resetMenu(res, userRoute) {
                // 用户没有菜单时，采用全部菜单
                if (!userRoute.length) {
                    res.forEach((item) => Vue.set(item, 'check', true));
                    return res;
                }

                // 当角色下的菜单改变时，重新构建所有的菜单
                // 1. 角色下的菜单新增，用户的菜单 + 角色新增的
                let arrSum = res.filter((item) => {
                    return userRoute.every((val) => val?.id !== item.id);
                });
                if (arrSum.length) {
                    userRoute = [...userRoute, ...arrSum];
                }
                // 2. 角色下的菜单删除，用户菜单 - 角色删除的
                let index = userRoute.findIndex((item) => {
                    return res.every((val) => val.id !== item?.id);
                });
                index > -1 && userRoute.splice(index, 1);
                // 3. check 为false  时，对比 menuList 与用户菜单的数据，给menulist添加check，并重新排序菜单
                let arr = userRoute;
                arr.forEach((item) => {
                    res.find((val) => val.id == item.id && Object.assign(item, val));
                });
                return arr;
            }
        },
        // 设置state数据
        setStateData(state, data) {
            let { key, value } = data;
            if (!state[key]) return;
            state[key] = value;
        },
        // 设置城市信息
        setCity(state, data) {
            state.cityData = data
            storage.ss.set('cityData', JSON.stringify(data))
        },
        // ca
        /* 设置当前课程 */
        setCACourse(state, data) {
            state.CACourse = data;
        },
        /* 设置当前正在编辑的模板item */
        setCASchedule(state, data) {
            state.CASchedule = data;
        },
        // ca end
        // 训练营
        setCampMgmt(state, data) {
            state.campMgmt = data;
        },
        setTrainingCamp(state, data) {
            state.trainingCamp = data;
        },
        // 训练营 end
        // 保存考核中的模板
        setCurrentAssess(state, data) {
            state.currentAssess = data;
        },
        // 设置对比球员
        setPlayerComparison(state,playerComparison){
            state.playerComparisonList = playerComparison;
            storage.ls.set('playerComparisonList', playerComparison);
        },
    },
    actions: {
        // 退出登录
        LogOut({ commit }) {
            return new Promise((resolve) => {
                commit('setLoading', false);
                commit('setToken', '');
                commit('setTenant', '');
                commit('setGroup', '');
                commit('setTenantData', {});
                commit('setChildTenantData', {});
                commit('setUserData', {});
                resolve('success');
            });
        },
        // 切换俱乐部
        changeTenant({ commit }) {
            return new Promise((resolve) => {
                commit('setLoading', false);
                commit('setTenant', '');
                commit('setGroup', '');
                commit('setTenantData', {});
                commit('setChildTenantData', {});
                commit('setUserData', {});
                resolve('success');
            });
        },
        GetPermissionList({ commit }, data) {
            return new Promise((resolve, reject) => {
                server
                    .getOwn_auths(data)
                    .then((res) => {
                        if (res.code === 200) {
                            if (res.data.length > 0) {
                                resolve(res.data);
                            } else {
                                reject();
                            }
                        } else {
                            reject();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        reject();
                    });
            });
        },
    },
});

